import { LoginResponseUser } from "./../../data/api-types/user/LoginResponseDto";
import { UserTypes } from "@utils/common/activeAccountEnum";

export function isUserAuthenticated(
	activeAccount: UserTypes = UserTypes.PRIMARY
): boolean {
	let userToken = getUserToken(activeAccount);
	if (userToken) {
		return true;
	}
	return false;
}

export function getShopId(
	activeAccount: UserTypes = UserTypes.PRIMARY
): string {
	if (activeAccount === UserTypes.PRIMARY) {
		return App.state.rootStore.userAuthStore.shopId;
	}
	return App.state.rootStore.userAuthStore.secondaryShopId;
}

export function getAgencyKey(
	activeAccount: UserTypes = UserTypes.PRIMARY
): string {
	if (activeAccount == UserTypes.PRIMARY) {
		return App.state.rootStore.userAuthStore.agencyKey;
	}
	return App.state.rootStore.userAuthStore.secondaryAgencyKey;
}

export function getAgencyId(
	activeAccount: UserTypes = UserTypes.PRIMARY
): string {
	if (activeAccount == UserTypes.PRIMARY) {
		return App.state.rootStore.userAuthStore.agencyId;
	}
	return App.state.rootStore.userAuthStore.secondaryAgencyId;
}

export function getUserId(
	activeAccount: UserTypes = UserTypes.PRIMARY
): string {
	if (activeAccount == UserTypes.PRIMARY) {
		return App.state.rootStore.userAuthStore.user?.id || "";
	}
	return App.state.rootStore.userAuthStore.secondaryUser?.id || "";
}

export function getUsername(
	activeAccount: UserTypes = UserTypes.PRIMARY
): string {
	if (activeAccount == UserTypes.PRIMARY) {
		return App.state.rootStore.userAuthStore.user?.username || "";
	}
	return App.state.rootStore.userAuthStore.secondaryUser?.username || "";
}

export function getUserToken(
	activeAccount: UserTypes = UserTypes.PRIMARY
): { token: string } | null {
	if (activeAccount === UserTypes.PRIMARY) {
		return App?.state?.rootStore?.userAuthStore.token;
	}
	return App?.state?.rootStore?.userAuthStore.secondaryToken;
}

// TODO user obj
export function getUserFromLocalStorage(
	activeAccount: UserTypes = UserTypes.PRIMARY
): LoginResponseUser | null {
	if (activeAccount == UserTypes.PRIMARY) {
		return App.state.rootStore.userAuthStore.user;
	}

	return App.state.rootStore.userAuthStore.secondaryUser;
}

export function getSecondaryUser(): LoginResponseUser | null {
	return App.state.rootStore.userAuthStore.secondaryUser;
}

export function getAccountActivationToken(): string | null {
	return (
		App.state.rootStore.userAuthStore.accountActivation?.activationToken ||
		null
	);
}
